exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-list[data-v-ce6f1ca6]{margin-left:-15px;margin-right:-15px}.alert-list .alert[data-v-ce6f1ca6],.alert-list .alert[data-v-ce6f1ca6] ol:last-of-type,.alert-list .alert[data-v-ce6f1ca6] ul:last-of-type{margin-bottom:0}.jumbotron~.alert-list[data-v-ce6f1ca6]{margin-top:-2rem;margin-bottom:2rem}.jumbotron~.alert-list[data-v-ce6f1ca6]:empty{margin-top:unset;margin-bottom:unset}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ce6f1ca6","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/AlertList.vue
// module id = 48
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17